"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["tag"];
var Tag = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var tag = _ref.tag,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (!tag) return null;
  return /*#__PURE__*/_react["default"].createElement(StyledTag, (0, _extends2["default"])({}, props, {
    title: tag
  }), tag);
});
Tag.displayName = 'Tag';
Tag.propTypes = {
  className: _propTypes["default"].string,
  tag: _propTypes["default"].string.isRequired
};
Tag.defaultProps = {
  className: ''
};
var StyledTag = _styledComponents["default"].span.withConfig({
  displayName: "Tag__StyledTag",
  componentId: "sc-23r1ou-0"
})(["color:#919499;font-size:12px;::before{content:'#';}"]);
var _default = exports["default"] = Tag;